/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC } from 'react'
import { Link } from 'react-router-dom'
import { Languages } from './Languages'
import { toAbsoluteUrl } from '../../../helpers'
import { useAuth } from '../../../../app/modules/auth/core/AuthProvider'

const HeaderUserMenu: FC = () => {
  const { user, username, logout } = useAuth()
  return (
    <div
      className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-275px'
      data-kt-menu='true'
    >
      <div className='menu-item px-3'>
        <div className='menu-content d-flex align-items-center px-3'>
          <div className='symbol symbol-50px me-5'>
            <img alt='Logo' src={toAbsoluteUrl('/media/auth/login-bg.jpg')} />
          </div>

          <div className='d-flex flex-column'>
            <div className='fw-bolder d-flex align-items-center fs-5' style={{ color: '#004F44' }}>
              {username}
            </div>
          </div>
        </div>
      </div>

      <div className='separator my-2'></div>
      {/*
      <div className='menu-item px-5'>
        <Link to={'#'} className='menu-link px-5'>
          Profile
        </Link>
      </div>
      <div className='separator my-2'></div>

      <Languages />

      <div className='menu-item px-5 my-1'>
        <Link to='/#' className='menu-link px-5'>
          Account Settings
        </Link>
      </div>
      */}

      <div className='menu-item px-5'>
        <a onClick={logout} className='menu-link px-5'>
          Sign Out
        </a>
      </div>
    </div>
  )
}

export { HeaderUserMenu }
